export default "__VITE_ASSET__Bc$cJw5T__"